import React, { useState, useEffect, useCallback } from 'react';
import { SnackbarContext } from './controller';
import * as Styled from './styles';

const [SnackbarProvider, useSnackbar] = SnackbarContext;

export default function Snackbar({ children }) {
  const [isVisible, setVisible] = useState(false);
  const [content, setContent] = useState(null);
  const [duration, setDuration] = useState(7000);
  const [showClose, setShowClose] = useState(false);
  const [type, setType] = useState('primary');

  const show = useCallback(
    (_content, options = {}) => {
      if (options.duration) setDuration(options.duration);
      if (options.type) setType(options.type);
      setContent(_content);
      setShowClose(options.showClose);
      setVisible(true);
    },
    [],
  );

  useEffect(() => {
    if (isVisible) {
      const timeout = setTimeout(() => {
        setVisible(false);
      }, duration);
      return () => clearTimeout(timeout);
    }
  }, [isVisible, duration]);

  function onClose(event) {
    event.preventDefault();
    setVisible(false);
  }

  return (
    <SnackbarProvider value={{ isVisible, content, show, type }}>
      {isVisible && (
        <Styled.Div type={type} $isVisible={isVisible}>
          {showClose && <Styled.Close onClick={onClose}>&times;</Styled.Close>}
          <Styled.Content>{content}</Styled.Content>
        </Styled.Div>
      )}
      {children}
    </SnackbarProvider>
  );
}

export { useSnackbar };
